require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-christmas-self-care.json") })
        }
      }, "path---blog-christmas-self-care");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-christmas-self-care!./.cache/json/blog-christmas-self-care.json
// module id = 281
// module chunks = 231608221292675